import React from "react";
import TodoMember from "../../../../Pages/Home/TodoTray/TodoElement/TodoMember";
import PopupHeader from "../PopupHeader";

const TodoMembersDropdown = ({ popupData, closePopup }) => {
  return (
    <div
      className="rounded-md shadow-1 bg-white"
      style={{ maxWidth: "250px", minWidth: "250px" }}
    >
      <PopupHeader closePopup={() => closePopup()} />
      <div className="flex flex-col overflow-y-scroll  p-3 gap-3">
        {popupData?.members?.map((item) => {
          return (
            <TodoMember
              key={`todo-member-${item?.user}`}
              member={item}
              showName
              closeModal={() => {
                popupData?.closeModal();
                closePopup();
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default TodoMembersDropdown;
